export default function SalesPageScript() {
  const isSalePage = document.querySelector('#salesPage');
  const { hash } = document.location;

  if (!isSalePage || !hash) {
    return null;
  }
  const sale = document.querySelector(hash);

  if (sale) {
    const btn = sale.querySelector('*[data-id="btn_table"]');
    if (btn) {
      btn.click();

      const parentContainerElements = document.querySelectorAll('.parent_container');
      parentContainerElements.forEach((container) => container.classList.remove('show-slider'));

      const parentContainerElement = sale.closest('.parent_container');
      parentContainerElement.classList.add('show-slider');

      const tabs = document.querySelectorAll('.slider-block .tabs-container .tab');
      tabs.forEach((tab) => tab.classList.remove('tab-active'));

      const parentContainerId = parentContainerElement.id;
      document.querySelector(`[data-tab="${parentContainerId}"]`).classList.add('tab-active');
    }
  }
}
